import DataTableV2 from "components/commons/data-table/data-table-v2";

const RedemptionList = ({ table }) => {
  return <DataTableV2 {...table} />;
};

export default RedemptionList;
